/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function DeliveryItemsFromLanguagesSearchViewController(this: JS5Object, LanguagesService: JS5Object, uiGridConstants: JS5Object,
                                                        PartnerEditService: JS5Object, $timeout: JS5Function) {


    const setLanguageRadioSelection = () => {
        this.languagesBeforeSelectAll = _.cloneDeep(this.editData.languages);
        this.languageRadioSelection = _.size(this.editData.languages) ? 'Custom' : 'All';
    };

    const setRowSelection = (row) => {
        if (row.isSelected) {
            this.editData.languages.push(row.entity);
        } else {
            _.remove(this.editData.languages, {id: row.entity.id});
        }
        this.editorForm.$setDirty();
    };

    this.onRowSelection = (row: JS5Object) => {
        setRowSelection(row);
    };

    this.onSelectAllToggled = () => {
        this.gridApi.selection.selectAllRows();
        if (this.gridApi.selection.getSelectedCount() !== _.size(this.editData.languages)) {
            this.editData.languages = _.cloneDeep(this.languages);
        } else {
            this.editData.languages = [];
            this.gridApi.selection.clearSelectedRows();
        }
        this.editorForm.$setDirty();
    };

    this.handleLanguageRadioSelectionChanged = () => {
        switch (this.languageRadioSelection) {
            case 'All':
                this.languagesBeforeSelectAll = _.cloneDeep(this.editData.languages);
                this.editData.languages = [];
                break;
            case 'Custom':
                this.editData.languages = _.cloneDeep(this.languagesBeforeSelectAll);
                this.processGridFilter(_.invoke(this.gridApi, 'core.getVisibleRows', this));
                break;
            default:
                break;
        }
    };

    this.processGridFilter = (renderableRows: JS5Object[]) => {
        _.forEach(renderableRows, (renderableRow) => {
            renderableRow.setSelected(_.some(this.editData.languages, {id: renderableRow.entity.id}));
        });
        return renderableRows;
    };


    const columnDefinitions = [
        {
            name: 'checkMarkRowHeaderCol',
            field: 'checkMark',
            width: 30,
            enableSorting: false,
            enableColumnResizing: false,
            headerCellTemplate: 'components/visual/grid/header-check-mark-component-template.html',
            cellTemplate: 'components/visual/grid/check-mark-template.html'
        }, {
            field: 'name',
            displayName: 'Language',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ];

    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        multiSelect: true,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        columnDefs: columnDefinitions,
        onRegisterApi: (gridApi: JS5Object) => {
            this.gridApi = gridApi;
            this.gridApi.grid.registerRowsProcessor(this.processGridFilter, 200);
            gridApi.selection.on.rowSelectionChanged(null, this.onRowSelection);
        },
        cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
    };


    this.$onInit = () => {
        this.gridOptions.data = _.cloneDeep(this.languages);
        this.showGrid = true;
        setLanguageRadioSelection();
    };
    this.$onChanges = () => {
        setLanguageRadioSelection();
        this.processGridFilter(_.invoke(this.gridApi, 'core.getVisibleRows', this));
    };

    this.$postLink = () => {
        $timeout(() => {
            PartnerEditService.editorForm = this.editorForm;
        });
    };
}

angular.module('prism-ui.deliveryProfiles').component('deliveryItemsFromLanguagesSearchView', {
    templateUrl: 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/common/from/languagesGrid/delivery-items-from-languages-grid-template.html',
    controller: DeliveryItemsFromLanguagesSearchViewController,
    bindings: {
        editData: '<',
        languages: '<'
    }
});
